/**
 * **Elite Hotels of Sweden**
 *
 * @exports partnership_430
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
      * @memberOf module:partnership_430
      */
    partnership.getId = function getId() {
        return '430';
    };
    /**
      * @memberOf module:partnership_430
      */
    partnership.check = function check() {
        return window.location.hostname.includes('elite');
    };
    /**
      * @memberOf module:partnership_430
      */
    partnership.boot = function boot() {
        if (!window.dataLayer) {
            return;
        }
        partnership.shutdown = thn.generateCallbackQueue();
        const refreshPartnership = thn.debounce(thn.siteCheck, 400, { maxWait: 800 });
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
            if (message.event === 'dsTransaction' || message.event === 'gtm.historyChange-v2') {
                refreshPartnership();
            }
        }, true);
        partnership.shutdown = function () {
            dataLayerHelper.unlisten();
            dataLayerHelper = null;
        };
    };
    /**
      * @memberOf module:partnership_430
      */
    partnership.getSiteId = function getSiteId() {
        const isBookingEngine = thn.isVisible(document.querySelector('[aria-label="Booking navigation"], [aria-label="Booking steps"]'));
        const isCorpo = (!isBookingEngine && !!window.location.pathname.match(/^\/(\w{2}\/)?$/) && (!!thn.parseUrlParameter('hotel') || !!thn.parseUrlParameter('location'))) // Corpo Index
            || (!isBookingEngine && !!window.location.pathname.match(/^\/(\w{2}\/?)?(hotels|hotell|packages|paket|vana-spa)\/([\w\d-]+)?\/?$/) && !thn.parseUrlParameter('hotel') && !thn.parseUrlParameter('location')) // Corpo pages
            || (isBookingEngine && !thn.parseUrlParameter('hotel') && !!thn.parseUrlParameter('location'));
        const hotelId = document.querySelector('.hotel-tab-general__rooms div[data-hotel-code], .hotel-landing-page')?.getAttribute('data-hotel-code') // Index
            || thn.parseUrlParameter('hotel') // R&R & URP
            || thn.objectGet(window.dataLayer, 'dsHotelCode', { first: false }); // BCP
        let result;
        if (hotelId && !isCorpo) {
            result = {
                externalId: hotelId,
            };
        }
        else if (isCorpo) {
            result = {
                accountKey: '654B27D4FEF80FC65DB1338590A81DCE',
            };
        }
        return result;
    };
    return partnership;
}

export { factory };
